import Header from "../../../components/Header"
import MapaMonitoreoFlota from "../../mapas/mapa_monitoreo_floja"

const ActividadFlota = (props) => {

    return <MapaMonitoreoFlota />
}

export default ActividadFlota